import { render, staticRenderFns } from "./cancel_policy.vue?vue&type=template&id=52d6e092&scoped=true&"
import script from "./cancel_policy.vue?vue&type=script&lang=js&"
export * from "./cancel_policy.vue?vue&type=script&lang=js&"
import style0 from "./cancel_policy.vue?vue&type=style&index=0&id=52d6e092&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d6e092",
  null
  
)

export default component.exports